import { Pipe, PipeTransform } from '@angular/core';

import { getLanguageDisplayName } from '@shared/utils';

@Pipe({
  name: 'languageDisplay',
  standalone: true,
})
export class LanguageDisplayPipe implements PipeTransform {
  transform(languageCode?: string): string {
    return languageCode ? getLanguageDisplayName(languageCode) : '';
  }
}
